import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const learnings = ['Cómo elegir una idea rentable.', 'Cómo convertir esa idea en un producto digital.', 'Cómo estructurar tu PDF o iBook.', 'Cómo diseñarlo fácilmente en Canva.', 'Cómo ponerle precio.', 'Cómo crear una oferta atractiva.', 'Cómo comenzar a venderlo usando redes sociales.', 'Cómo automatizar parte del proceso.'];
export function WhatYouLearn() {
  return <section className="py-24 px-6 bg-brand-bg relative" data-id="element-132">
      <div className="max-w-5xl mx-auto" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-134">
          <h2 className="text-3xl md:text-5xl font-black uppercase text-brand-navy mb-4 leading-tight" data-id="element-135">
            ¿Qué <span className="text-brand-accent" data-id="element-136">aprenderás?</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6 mb-16" data-id="element-137">
          {learnings.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-center gap-4 group" data-id="element-138">
              <div className="w-10 h-10 rounded-full bg-brand-accent flex items-center justify-center shrink-0 shadow-md shadow-brand-accent/30" data-id="element-139">
                <CheckCircle2 className="w-6 h-6 text-white" data-id="element-140" />
              </div>
              <p className="text-lg text-brand-text font-medium" data-id="element-141">{item}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-brand-navy py-8 px-6 rounded-2xl" data-id="element-142">
          <p className="text-xl font-bold text-white" data-id="element-143">
            Todo explicado de forma simple y para principiantes.
          </p>
        </motion.div>
      </div>
    </section>;
}